import { useTranslation } from 'react-i18next'

import { Grid, Typography } from '@mui/material'

import PageContainer from '@/components/ui/containers/PageContainer'
import { useOfflineMode } from '@/providers/OfflineModeProvider'
import { OfflineInitializing, OfflineStatusIndicator } from '@/shared/offline'

import { useConflictResolver } from '../model/useConflictResolver'
import { useSyncDashboard } from '../model/useSyncDashboard'
import { ConflictResolver } from './ConflictResolver/ConflictResolver'
import { SyncDashboard } from './SyncDashboard'

export function OfflineSyncPage() {
  const { t } = useTranslation()
  const { isOfflineDatabaseReady } = useOfflineMode()
  const {
    queueItems,
    loading: syncLoading,
    handleAction,
    syncStatus,
    sync,
    retryFailedItems,
    clearCompletedItems,
    clearAllOfflineData,
    refreshData,
  } = useSyncDashboard()
  const { conflicts, loading: conflictsLoading, resolveConflict, resolvePatientDuplicate } = useConflictResolver()

  if (!isOfflineDatabaseReady) {
    return <OfflineInitializing />
  }

  return (
    <PageContainer>
      <OfflineStatusIndicator />
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant="h4" gutterBottom>
            {t('offline.sync.title')}
          </Typography>
          <Typography variant="body1" color="text.secondary" paragraph>
            {t('offline.sync.subtitle')}
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <SyncDashboard
            syncStatus={syncStatus}
            queueItems={queueItems}
            onManualSync={() => handleAction(sync, 'Sync started', 'Manual sync failed')}
            onRetryFailed={() => handleAction(retryFailedItems, 'Retrying failed items', 'Retry failed')}
            onClearCompleted={() => handleAction(clearCompletedItems, 'Cleared completed items', 'Clear completed failed')}
            onRefresh={() => handleAction(refreshData, 'Data refreshed', 'Refresh failed')}
            onClearOfflineData={() => handleAction(clearAllOfflineData, 'Offline data cleared', 'Clear offline data failed')}
            loading={syncLoading}
          />
        </Grid>

        <Grid item xs={12}>
          <ConflictResolver
            conflicts={conflicts}
            loading={conflictsLoading}
            onResolveConflict={resolveConflict}
            onResolvePatientDuplicate={resolvePatientDuplicate}
          />
        </Grid>
      </Grid>
    </PageContainer>
  )
}
